import React, { useState } from "react";
import { useContext } from "react";
import { useNavigate } from 'react-router-dom';
import { useForm, Controller } from "react-hook-form"
import Select from 'react-select'

//import axios from 'axios';
import axios_api from "../../Api";

import { API_URL, MEDIA_URL, AUTH_TOKEN } from '../../Context';


export function TicketCreateForm () {

  const api_url = useContext(API_URL);
  const token = useContext(AUTH_TOKEN);
  const navigate = useNavigate();
  const [formError, setFormError] = useState(false)
  const [themes, setThemes] = useState([]);
  const [themesLoading, setThemesLoading] = useState(true);
  const [labs, setLabs] = useState([]);
  const currentYear = new Date().getFullYear();
  const years = [currentYear + 1, currentYear, currentYear - 1];

  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: { year: currentYear },
  });

  React.useEffect(() => {

    axios_api.get(api_url + '/allowed_tickets_themes/', {
      headers: {"Authorization": token},
    }).then(
      (result) => {
        setThemes(result.data);
        setThemesLoading(false);
      },
      (error) => {
        setFormError('Не удалось загрузить темы обращений, обновите страницу');
        setThemesLoading(false);
        console.log(error);
      }
    );

    axios_api.get(api_url + '/users/', {
      headers: {"Authorization": token},
    }).then(
      (result) => {
        setLabs(result.data);
      },
      (error) => {
        setFormError('Не удалось загрузить список лабораторий, обновите страницу');
        console.log(error);
      }
    );

  }, [api_url, token]);


  const onSubmit = (ticketData) => {

    let data = {
      ...ticketData,
      lab: ticketData.lab?.value,
    };

    axios_api.post(api_url + `/tickets_legal/`, data, {
      headers: {
        "Authorization": token,
        "Content-Type": "multipart/form-data",
      }
    })
    .then(
      (result) => {
        navigate("/tickets");
        navigate(0);
      },
      (error) => {
        const errorMessage = error.request.status === 413 ?
            'Размер файла превышает разрешенный размер на web-сервере' :
              error.response?.data ||
                'Ошибка создания обращения';
        setFormError(errorMessage);
      }
    );
  }

  const labOptions = labs.map((lab) => ({ value: lab.username, label: lab.username }));
  const canSubmit = !themesLoading && themes.length > 0 && labs.length > 0;

  return (
    <>
    <div className="lk-form">
      <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
        <div className="input-group my-3">
          <label className="mt-3 col-4">
            <p>Лаборатория</p>
            <div style={{width: '400px'}}>
              <Controller
                name="lab"
                control={control}
                rules={{ required: 'Выберите лабораторию' }}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={labOptions}
                    placeholder="Начните вводить код лаборатории"
                    isClearable
                    className={errors.lab ? "is-invalid" : ""}
                  />
                )}
              />
            </div>
            { errors.lab &&
              <p className="text-danger mt-1"><small>{errors.lab.message}</small></p>
            }
          </label>
        </div>
        <div className="input-group my-3">
          <label className="mt-3 col-4">
            <p>Тема обращения</p>
            <select
              className={errors.theme ? "form-select is-invalid" : "form-select"}
              style={{width: '400px'}}
              defaultValue=""
              {...register("theme", {required: 'Выберите тему обращения'})}
            >
              <option value="" disabled>Выберите тему обращения</option>
              {themes.map((theme) =>
                <option key={theme.id} value={theme.id}>{theme.theme_name}</option>
              )}
            </select>
            { errors.theme &&
              <p className="text-danger mt-1"><small>{errors.theme.message}</small></p>
            }
          </label>
        </div>
        <div className="input-group my-3">
          <label className="mt-3 col-4">
            <p>Год</p>
            <select className="form-select" style={{width: '400px'}} {...register("year", {required: true})}>
              {years.map((year) =>
                <option key={year} value={year}>{year}</option>
              )}
            </select>
          </label>
        </div>
        <div className="input-group my-3">
          <label className="mt-3 col-4">
            <p>Напишите сообщение</p>
            <textarea className="form-control" rows="3" style={{width: '400px'}} {...register("text", {required: 'Введите сообщение'})} ></textarea>
            { errors.text &&
              <p className="text-danger mt-1"><small>{errors.text.message}</small></p>
            }
          </label>
        </div>
        <div className="input-group mt-3">
          <label className="">
            <p>Приложенный файл</p>
            <input type="file" className="form-control" style={{width: '400px'}} {...register('attachment[]')}/>
          </label>
        </div>
        <p className="text-secondary mt-1"><small>максимальный размер файла 10 мб</small></p>
        { formError &&
          <p className="text-danger">{typeof formError === 'string' ? formError : 'Ошибка создания обращения'}</p>
        }
        {(!themesLoading && themes.length === 0 && !formError) &&
          <p className="text-danger">Нет разрешенных тем обращений. Инициировать обращение нельзя — обратитесь к администратору.</p>
        }
        {canSubmit ?
          <button type="submit" className="btn lk-button my-3">Отправить</button>
        :
          <button type="button" className="btn lk-button my-3" disabled>Отправить</button>
        }
      </form>
    </div>
    </>
  )
}


export function TicketUpdateForm ({ticketId, UpdateChat}) {

  //const media_url = useContext(MEDIA_URL);
  const api_url = useContext(API_URL);
  const token = useContext(AUTH_TOKEN);
  const navigate = useNavigate();
  const [formError, setFormError] = useState(false)

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {},
  });


  const onSubmit = (ticketData) => {

    let data = {...ticketData};

    console.log(data);

    axios_api.put(api_url + `/manage_ticket_legal/` + ticketId, data, {
      //paramsSerializer: { indexes: null },
      headers: {
        "Authorization": token, 
        "Content-Type": "multipart/form-data",
      }
    })
    .then(
      (result) => {
        console.log("success");
        navigate("/ticket/" + ticketId);
        navigate(0);
      },
      (error) => {
        const errorMessage = error.request.status === 413 ? 
            'Размер файла превышает разрешенный размер на web-сервере' : 
              error.response?.data || 
                'Ошибка добавления документа';
        setFormError(errorMessage);
        //console.log(error);
      }
    );
  }

  return (
    <div className="lk-form">
      <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
        <div className="input-group mb-3">  
          <label className="col-4">
            <p>Сообщение</p>
            <textarea className="form-control" rows="2"  style={{width: '400px'}} {...register("text")} ></textarea>
          </label>
        </div>
        <div className="input-group mt-3">
          <label className="">
            <p>Вложение</p> 
            <input type="file" className="form-control" style={{width: '400px'}} {...register('attachment')}/>
          </label>
        </div>
        <p className="text-secondary mt-1"><small>максимальный размер файла 10 мб</small></p>
        { formError &&
          <p className="text-danger">{formError}</p>
        }
        {(20 > 10) ?
          <button type="submit" className="btn lk-button my-3">Отправить</button>
        :
          <button type="button" className="btn lk-button my-3" disabled>Отправить</button>
        }
      </form>
    </div>
  )
}
